module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "customPadding",
    attrs: {
      "to": '/',
      "tag": "a"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Logout.apply(null, arguments)
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.Logout
    }
  }, [_vm._v("Salir")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9b47cad8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b47cad8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/membership/Logout.vue
// module id = 126
// module chunks = 0